import { SelectableCard } from './SelectableCard';

export interface ProductCategoryOption {
    value: string;
    label: string;
}

interface Step4ProductCategoryProps {
    title: string;
    options: ProductCategoryOption[];
    value: string | null;
    onSelect: (value: string) => void;
}

export const Step4ProductCategory = ({
    title,
    options,
    value,
    onSelect,
}: Step4ProductCategoryProps) => {
    return (
        <div className="flex flex-col gap-[1.375rem]">
            <h2 className="text-[1.3125rem] leading-[1.1] font-medium tracking-[-0.02em] text-[#161616] uppercase">
                {title}
            </h2>
            <ul className="flex flex-col gap-2">
                {options.map((option) => (
                    <li key={option.value}>
                        <SelectableCard
                            title={option.label}
                            selected={value === option.value}
                            onClick={() => onSelect(option.value)}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
